<template>
  <div>
    <div class="d-flex justify-content-center">
      <vb-icon class="mr-3" :name="'symbol_vv'" />
      <h3 class="vb-heading" v-html="'Cerchi solamente un volo?'"></h3>
    </div>
    <div class="d-flex justify-content-center mt-5">
      <a
        href="https://voli.vadobay.com/"
        target="_blank"
      ><img
        class="px-4"
        src="assets/images/common/brands/fly-by-payoff.svg"
        alt="VadoBay fly by"
      /></a>
    </div>
    <p
      class="text-center mt-5"
    >
      Cerca il nostro servizio <strong>fly by VadoBay</strong> sul tuo
      portale welfare.
    </p>
  </div>
</template>

<script>
export default {
  name: 'fly-by',
};
</script>
